/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { DimConfigurationFragmentDoc } from "../../dim-configuration/graphql/fragments.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type FollowUpConfigurationFragment = {
  __typename: "FollowUpConfiguration"
  id: string
  position: number
  isActive?: boolean | null
  sourceProduct: {
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }
  targetProduct: {
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }
}

export const FollowUpConfigurationFragmentDoc = gql`
  fragment FollowUpConfiguration on FollowUpConfiguration {
    id
    sourceProduct {
      ...DimConfiguration
    }
    targetProduct {
      ...DimConfiguration
    }
    position
    isActive
  }
  ${DimConfigurationFragmentDoc}
`
